<template>
  <div id="app">
    <!-- <HearTop></HearTop> -->
    <router-view/>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import HearTop from './components/navTop/hearTop'
import Footer from './components/navTop/footer'
export default {
  name: 'App',
  components:{
    HearTop,
    Footer,
  },
  mounted() {
    console.log(this.$router)
  }
}
</script>

<style>
@import '//at.alicdn.com/t/font_1205595_1oofvhrumz.css';
html, body, ul, li, ol, dl, dd, dt, p, h1, h2, h3, h4, h5, h6, form, fieldset, legend, img {
    margin: 0;
    padding: 0;
}
input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill {
    -webkit-box-shadow:0 0 0px 1000px white inset;
    background: #fff;
    box-shadow:0 0 0px 1000px white inset;
    outline: none;
} 
input[type=text]:focus, input[type=password]:focus, textarea:focus { 
-webkit-box-shadow: 0 0 0px 1000px white inset;
    border:0;
    box-shadow:0 0 0px 1000px white inset;
    background: #fff;
    outline: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue